<!--
  ALTA DE UNA TIENDA — página con ruta propia, a todo el ancho.
  Era el modal `formTiendaAbierto` de la ficha del comercio.

  El espaciado agrupa, y son tres distancias que se tienen que notar:
    · 0.375rem dentro de un campo (rótulo → casilla → ayuda)
    · 1.25rem  entre campos  (gap-5)
    · 2.5rem   entre bloques (mt-10)
-->
<div class="kb-page">

  <!-- ══ Migas — de dónde se viene ════════════════════════════════════════════ -->
  <nav class="kb-migas" aria-label="Ubicación">
    <a class="kb-miga" [routerLink]="['/console/merchants']">Comercios</a>
    <span class="kb-miga-sep" aria-hidden="true"><i class="fas fa-chevron-right"></i></span>
    <a class="kb-miga" [routerLink]="['/console/merchants', codigo]">{{ comercio?.name || codigo }}</a>
    <span class="kb-miga-sep" aria-hidden="true"><i class="fas fa-chevron-right"></i></span>
    <a class="kb-miga" [routerLink]="['/console/merchants', codigo, 'tiendas']">Tiendas</a>
    <span class="kb-miga-sep" aria-hidden="true"><i class="fas fa-chevron-right"></i></span>
    <span class="kb-miga-actual">Nueva tienda</span>
  </nav>

  <!-- ══ Encabezado ═══════════════════════════════════════════════════════════ -->
  <div class="kb-page-header">
    <div class="min-w-0">
      <h1 class="kb-page-title">Nueva tienda</h1>
      <p class="kb-page-meta" *ngIf="!cargando && !noEncontrado">
        {{ comercio?.name || codigo }} &middot; <span class="font-mono">{{ codigo }}</span>
      </p>
    </div>
    <div class="shrink-0" *ngIf="!cargando && !noEncontrado">
      <button type="button" class="kb-btn kb-btn-outline" [disabled]="guardando"
              (click)="volverATiendas()">
        <i class="fas fa-arrow-left" aria-hidden="true"></i>Volver a tiendas
      </button>
    </div>
  </div>

  <!-- ══ Cargando ═════════════════════════════════════════════════════════════ -->
  <div *ngIf="cargando" class="space-y-4" aria-live="polite" aria-busy="true">
    <div class="kb-skeleton h-14 w-full"></div>
    <div class="kb-skeleton h-9 w-full max-w-xl" *ngFor="let s of [1,2,3]"></div>
  </div>

  <!-- ══ No existe el comercio ════════════════════════════════════════════════ -->
  <div class="kb-empty" *ngIf="!cargando && noEncontrado">
    <span class="kb-empty-icono"><i class="fas fa-store-slash" aria-hidden="true"></i></span>
    <p class="kb-empty-titulo">No encontramos el comercio «{{ codigo }}»</p>
    <p class="kb-empty-texto">Puede que el código esté mal escrito.</p>
    <a class="kb-btn kb-btn-outline mt-4" [routerLink]="['/console/merchants']">
      <i class="fas fa-arrow-left" aria-hidden="true"></i>Volver a comercios
    </a>
  </div>

  <ng-container *ngIf="!cargando && !noEncontrado">

    <!-- 🔴 La cinta de la pantalla, y va sola: de la tienda donde se vende sale
         a qué comercio pertenece el crédito. Es lo que hay que saber ANTES de
         crearla, no después. -->
    <!-- Sin permiso no se dibuja el formulario: se dice por qué. -->
    <div class="kb-empty" *ngIf="!puedeCrear()">
      <span class="kb-empty-icono"><i class="fas fa-lock" aria-hidden="true"></i></span>
      <p class="kb-empty-titulo">No tienes permiso para crear tiendas</p>
      <p class="kb-empty-texto">
        Lo habilita el permiso «crear tiendas» de la configuración de comercios.
      </p>
      <a class="kb-btn kb-btn-outline mt-4" [routerLink]="['/console/merchants', codigo, 'tiendas']">
        <i class="fas fa-arrow-left" aria-hidden="true"></i>Volver a tiendas
      </a>
    </div>

    <div class="kb-cinta kb-cinta-info" *ngIf="puedeCrear()">
      <i class="fas fa-info-circle kb-cinta-icono" aria-hidden="true"></i>
      <p class="m-0">
        <strong class="font-semibold">Las ventas de esta tienda serán de
        {{ comercio?.name || codigo }}.</strong>
        De la tienda donde se vende sale a qué comercio pertenece el crédito.
      </p>
    </div>

    <section class="kb-tarjeta" *ngIf="puedeCrear()">
      <div class="kb-tarjeta-cab">
        <h2 class="text-base font-semibold leading-none">Identificación</h2>
      </div>
      <div class="kb-tarjeta-cuerpo">

      <div class="grid max-w-3xl grid-cols-1 gap-5 sm:grid-cols-2">
        <div>
          <label class="kb-label" for="tCodigo">Código <span class="text-destructive">*</span></label>
          <input id="tCodigo" type="text" class="kb-input font-mono" placeholder="CM-01"
                 [(ngModel)]="form.code" name="code" maxlength="20">
          <p class="kb-hint">Letras, números, guion, punto o guion bajo; sin espacios. Te proponemos uno; puedes cambiarlo. No se puede repetir.</p>
          <p *ngIf="codigoMal" class="mt-1 text-xs text-destructive">Ese código lleva un carácter que no se acepta.</p>
        </div>
        <div>
          <label class="kb-label" for="tNombre">Nombre <span class="text-destructive">*</span></label>
          <input id="tNombre" type="text" class="kb-input" placeholder="EPA La Trinidad"
                 [(ngModel)]="form.name" name="name">
        </div>
        <div>
          <label class="kb-label" for="tCorto">Nombre corto <span class="text-destructive">*</span></label>
          <input id="tCorto" type="text" class="kb-input" maxlength="30" placeholder="La Trinidad"
                 [(ngModel)]="form.short_name" name="short_name">
        </div>
        <div>
          <label class="kb-label" for="tCiudad">Ciudad</label>
          <input id="tCiudad" type="text" class="kb-input" placeholder="Caracas"
                 [(ngModel)]="form.city" name="city">
        </div>
        <div class="sm:col-span-2">
          <label class="kb-label" for="tDir">Dirección</label>
          <input id="tDir" type="text" class="kb-input" placeholder="Av. principal, local 4"
                 [(ngModel)]="form.address" name="address">
        </div>
      </div>
      </div>
    </section>

    <!-- El botón de crear, siempre a la vista. -->
    <div class="kb-barra-pie" *ngIf="puedeCrear()">
      <p class="kb-barra-nota" *ngIf="!valido">
        <i class="fas fa-exclamation-triangle mr-1" aria-hidden="true"></i>
        Faltan el código y el nombre de la tienda.
      </p>
      <p class="kb-barra-nota" *ngIf="valido">
        Queda asignada a {{ comercio?.name || codigo }}.
      </p>
      <div class="flex items-center gap-2">
        <button type="button" class="kb-btn kb-btn-ghost" [disabled]="guardando"
                (click)="volverATiendas()">Cancelar</button>
        <button type="button" class="kb-btn kb-btn-primary"
                [disabled]="!valido || guardando" (click)="crear()">
          <i class="fas" [ngClass]="guardando ? 'fa-spinner fa-spin' : 'fa-check'"
             aria-hidden="true"></i>
          {{ guardando ? 'Creando…' : 'Crear la tienda' }}
        </button>
      </div>
    </div>

  </ng-container>
</div>
